(function( $ ){
  $(function(){

    console.log('> theme.js: init');

    $('.faq-box').on('click', function(){
      var $box = $(this);
      var isOpen = $box.find('.faq-box__question').hasClass('active-question');

      $('.faq-box').find('.faq-box__question').removeClass('active-question');
      $('.faq-box').find('.faq-box__answer').removeClass('active-answer');

      if (!isOpen) {
        $box.find('.faq-box__question').addClass('active-question');
        $box.find('.faq-box__answer').addClass('active-answer');
      }
    });

    const swiperPartners = new Swiper('.swiper--partners', {
      
      loop: true,
      slidesPerView: 2,
      slidesPerGroup: 1,
      autoplay: {
       delay: 5000,
     },
      breakpoints: {  
          '575': {
            slidesPerView: 5,
            slidesPerGroup: 2,
        },
      }
      
    });

    

    const swiperFeaturedProducts = new Swiper('.swiper--featured-products', {
      
      slidesPerView: 2,
      initialSlide: 0,
      centeredSlides: true,
      pagination: {
        el: ".swiper--featured-products .swiper-pagination",
      },

     breakpoints: {  
      '760': {
          slidesPerView:3,
          initialSlide: 1,
          centeredSlides: false,

      },
  }
      
    });

    const swiperProdTestimonials = new Swiper('.swiper--prod-testimonials', {
      
      loop: true,
      slidesPerView: 3,
      slidesPerGroup: 1,
      autoplay: {
       delay: 5000,
      },
      pagination: {
        el: ".swiper--prod-testimonials .swiper-pagination",
      },
      breakpoints: {  
          '575': {
              slidesPerView: 6,
              slidesPerGroup: 1,
          },
      }
      
    });



    const swiperProdGallery = new Swiper('.swiper--product-gallery', {
      
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 2,
      pagination: {
        el: ".swiper--product-gallery .swiper-pagination",
      },
      navigation: {
        nextEl: '.swiper--product-gallery .swiper-button-next',
        prevEl: '.swiper--product-gallery .swiper-button-prev'
      },
      breakpoints: {  
          '575': {
              slidesPerView: 5,
              slidesPerGroup: 2,
          },
      }
      
    });

    $('.header .header__inline-menu header-menu').hover(function(){
      $('details').prop('open', true)
    }, function(){
      $('details').prop('open', false)
    });


    $('.js--gallery-option').on('click', function(){
      let href = $(this).attr('data-url');

      $('.js--gallery-main').find('img').attr('src', href);
    })
    
    
  });
})( jQuery );